<template>
  <icon-chevron-up
    class="transform cursor-default text-gray-700 transition-all"
    :class="{ 'rotate-180': isOpen, 'mt-1 mr-4': isDefaultPosition }"
    :fill="fill"
  />
</template>

<script setup lang="ts">
import IconChevronUp from "@/components/icons/deals/IconChevronUp.vue";

defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  isDefaultPosition: {
    type: Boolean,
    default: true,
  },
  fill: {
    type: String,
    default: "#9ca3af",
  },
});
</script>
